import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ceap_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token invalid — nuke session and redirect
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("ceap_token");
        localStorage.removeItem("ceap_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const ROLES = {
  COMERCIAL: "COMERCIAL",
  SECRETARIA: "SECRETARIA",
  CONSULTOR: "CONSULTOR",
  JURIDICO: "JURIDICO",
  DIRETORA: "DIRETORA",
  CLIENTE: "CLIENTE",
};

export const ROLE_LABEL = {
  COMERCIAL: "Comercial",
  SECRETARIA: "Secretaria",
  CONSULTOR: "Consultor",
  JURIDICO: "Controlador Jurídico",
  DIRETORA: "Diretora de Projeto",
  CLIENTE: "Cliente",
};

export function getHomeRouteByRole(role) {
  switch (role) {
    case ROLES.COMERCIAL:
      return "/comercial";
    case ROLES.SECRETARIA:
      return "/secretaria/dashboard";
    case ROLES.CONSULTOR:
      return "/consultor/dashboard";
    case ROLES.JURIDICO:
      return "/juridico/dashboard";
    case ROLES.DIRETORA:
      return "/diretora/dashboard";
    case ROLES.CLIENTE:
      return "/portal";
    default:
      return "/login";
  }
}

export function formatDateBR(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function formatDateTimeBR(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatCurrencyBR(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

export function monthName(m) {
  return [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
  ][m - 1] || "";
}
